<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        技能者編集 - {{ name }}
        <div class="headerBtn" @click="screenTransition(workerslistPath)" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading type="cylon" color="#1b7e47" :size="{ width: '150px', height: '150px' }">
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{ errorMessage }}
          </div>
        </div>
      </div>
      <form v-if="!getLodingFlg && !getErrorFlg">
        <validation-observer ref="obs" v-slot="ObserverProps">

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              氏名【必須】
            </div>
            <div class="row">
              <p class="inputTitle editable">姓</p>
              <validation-provider name="姓" rules="required|max:32|valid_characters" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text short" v-model="detail.lastName" :placeholder="before.lastName">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">名</p>
              <validation-provider name="名" rules="required|max:32|valid_characters" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text short" v-model="detail.firstName" :placeholder="before.firstName">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">フリガナ（姓）</p>
              <validation-provider name="フリガナ（姓）" rules="required|max:32|furigana" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text short" v-model="detail.lastNameKana" :placeholder="before.lastNameKana">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">フリガナ（名）</p>
              <validation-provider name="フリガナ（名）" rules="required|max:32|furigana" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text short" v-model="detail.firstNameKana" :placeholder="before.firstNameKana">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              基本情報【任意】
            </div>
            <div class="row">
              <p class="inputTitle editable">性別</p>
              <validation-provider name="性別" mode="lazy">
                <div class="rowRight" slot-scope="genderProps">
                  <div class="selectdiv">
                    <select v-model="detail.genderId">
                      <option value="" selected>性別</option>
                      <option v-for="gender in optionGender" v-bind:value="gender.id">
                        {{ gender.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">電話番号</p>
              <validation-provider name="電話番号" rules="min:10|max:14|numeric" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.tel" :placeholder="before.tel">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">メールアドレス</p>
              <validation-provider name="メールアドレス" rules="max:255|emailVaridate|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" v-model="detail.email" :placeholder="before.email">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              住所【任意】
            </div>
            <div class="row">
              <p class="inputTitle editable">国籍</p>
              <validation-provider name="国籍" rules="required" mode="lazy">
                <div class="rowRight" slot-scope="nationalityProps">
                  <div class="selectdiv">
                    <input type="text" class="text large" name="nationality" v-model="detail.nationalityObj.name"
                      :placeholder="before.nationalityObj.name" readonly />
                    <!-- {{ detail.nationalityObj.name }} -->
                  </div>
                  <div class="errMsg" v-if="nationalityProps.errors[0]">
                    <span class="errSpan">
                      {{ nationalityProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">郵便番号</p>
              <validation-provider name="郵便番号" rules="digits:7|addressFlg" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" v-on:change="getAddress(detail)" class="text large" name="postalCode"
                    v-model="detail.postalCode" placeholder="例：1000001 ハイフン無し半角数字のみ入力" />
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan" v-if="postalHasError">
                      {{ ProviderProps.errors[0] }}
                    </span>
                    <span class="prefectureErrSpan" v-if="!postalHasError">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">都道府県</p>
                <validation-provider name="都道府県" rules="max:255" mode="lazy">
                    <div class="rowRight" slot-scope="ProviderProps">
                      <input type="text" class="text large" :placeholder="'例：東京都'" name="prefecture"
                      v-model="detail.prefecture">
                        <div class="errMsg" v-if="ProviderProps.errors[0]">
                          <span class="errSpan" v-if="postalHasError">
                            {{ ProviderProps.errors[0] }}
                          </span>
                        </div>
                    </div>
                </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">市区町村</p>
              <validation-provider name="町・番地" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" class="text large" :placeholder="'例：千代田区'" name="city" v-model="detail.city"/>
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">町・番地</p>
              <validation-provider name="町・番地" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" class="text large" :placeholder="'例：丸の内1-1'" name="town" v-model="detail.town"/>
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">建物名/部屋番号</p>
              <validation-provider name="建物名/部屋番号" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" class="text large" name="otherAddress" v-model="detail.otherAddress"
                    :placeholder="before.otherAddress" />
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>
          <!-- ローディング -->
          <div v-if="postLodingFlg">
            <vue-loading type="cylon" color="#1b7e47" :size="{ width: '150px', height: '150px' }">
            </vue-loading>
            <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
          </div>
          <!-- 登録エラー表示 -->
          <div v-if="putErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
            <div　class="errMsg">
              <div class="errDiv">
                データの更新中に問題が発生しました。
              </div>
            </div>
          </div>
          <!-- 入力チェックエラー表示 -->
          <div v-if="validationErrMsg.length > 0">
            <div　class="errMsg" v-for="error in validationErrMsg">
              <div class="errSpan">{{ error }}</div>
            </div>
          </div>
          <div class="buttonGroup">
            <button class="btn" type="button" @click="confirm"
              v-bind:class="{ disabled: isProcessing() || !ObserverProps.validate 
              ||!isPostDisabled(ObserverProps,postalHasError)
              || detail.lastName === ''
              || detail.firstName === ''
              || detail.lastNameKana === ''
              || detail.firstNameKana === ''
              || detail.genderId ==='',
              active: isPostDisabled(ObserverProps,postalHasError)
              && detail.lastName !== ''
              && detail.firstName !== ''
              && detail.lastNameKana !== ''
              && detail.firstNameKana !== ''
              && detail.genderId !==''
              && ObserverProps.validate }"
              :disabled="!isPostDisabled(ObserverProps,postalHasError)
              || detail.lastName === ''
              || detail.firstName === ''
              || detail.lastNameKana === ''
              || detail.firstNameKana === ''
              || detail.genderId ===''">変更
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import common from '../services/common';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';

export default {
  title: '技能者編集',
  name: 'WorkerEdit',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  props: {
    id: {
      type: String,
      default: '0',
      required: true,
    },
    name: {
      type: String,
      default: '',
      required: true,
    },
  },
  // setup() {
  //   return {
  //   },
  // },
  data() {
    return {
      workerslistPath: '/workers', // 技能者一覧パス
      // 登録用モデル
      detail: {
        // 氏名【必須】
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        nationality: '',
        workerName: '',
        // 基本情報【任意】
        genderId: '',
        tel: '',
        email: '',
        // 住所【任意】
        postalCode: '',
        prefecture: '',
        city: '',
        town: '',
        otherAddress: '',
        fullAddress: '',
        // CCUS-GWアカウント情報 用途不明
        loginId: '',
        contactEmail: '',
        nationalityObj: {},
        // CCUS登録情報　用途不明
        ccusId: '',
        ccusNo: '',
      },
      // プレースホルダー用元値
      before: {
        // 氏名【必須】
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        // 基本情報【任意】
        genderId: '未設定',
        tel: '未設定',
        email: '未設定',
        // 住所【任意】
        postalCode: '未設定',
        prefecture: '未設定',
        city: '未設定',
        town: '未設定',
        otherAddress: '未設定',
        fullAddress: '',
        // CCUS-GWアカウント情報
        loginId: '',
        contactEmail: '',
        nationalityObj: {},
      },
      // ドロップダウンリスト
      // 選択した性別用
      selectedgender: '',
      // 選択用性別配列
      // TODO 性別IDリスト取得API要作成？
      optionGender: [
        {
          id: 'ge3138a7-ccdd-48ea-ad39-fc455bcfe134',
          name: '男性',
        },
        {
          id: 'ge2138a7-ccdd-48ea-ad39-fc455bcfe134',
          name: '女性',
        },
        {
          id: 'ge1138a7-ccdd-48ea-ad39-fc455bcfe134',
          name: 'その他',
        },
      ],
      // 国籍（日本：１　海外：２）
      nationalityList: [
        {
          id: 1,
          name: '日本',
        },
        {
          id: 2,
          name: '海外',
        },
      ],
      selectedprefs: '', // 選択した都道府県用
      optionprefs: [],   // 選択用都道府県配列
      // ローディング
      getLodingFlg: true,     // データ取得時ローディング用フラグ
      getErrorFlg: false,      // データ取得時エラーフラグ
      postLodingFlg: false,    // データ登録時ローディングフラグ
      putErrorFlg: false,     // データ登録時エラーフラグ
      // 入力チェック
      validationErrFlg: false, // 入力チェックエラーフラグ
      processing: false,
      validationErrMsg: [],    // 入力チェックエラーメッセージ用配列
      errorMessage: '',
      // 郵便番号エラー判定用フラグ
      postalHasError:true,
    };
  },
  async mounted() {
    try {
      // 技能者一意情報取得API呼出
      await this.setWorker(this.id, this.detail, this.before, this.nationalityList);
      // await new Promise((resolve) => setTimeout(resolve, 300));
    } catch (error) {
      this.errorMessage = error.message;

      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 郵便番号を元に住所取得
    async getAddress(detail) {
      const restResourceService = new ApiClient();
      await restResourceService.getAddress(detail.postalCode)
        .then((res) => {
          if(res === 404){
            this.postalHasError = false;
            this.detail.prefecture = "";
            this.detail.city = "";
            this.detail.town = "";
            this.detail.fullAddress = "";
          } else{
            this.postalHasError = true;
          this.detail.prefecture = res.pref;
          this.detail.city = res.city;
          this.detail.town = res.town;
          this.detail.fullAddress = res.fullAddress;
          }
        });
    },
    // // 都道府県リスト取得API呼出
    // async callGetprefs() {
    //   try {
    //     const restResourceService = new ApiClient();
    //     return await restResourceService.getprefs();
    //   } catch (error) {
    //     throw error;
    //   }
    // },
    // // 都道府県名からキーバリューを設定
    // prefConversion(value, list) {
    //   const result = list.find((v) => v.name === value);
    //   if (result) {
    //     return result.name;
    //   }
    // },
    // 技能者一意情報取得API呼出
    async setWorker(id, detail, before, nationalityList) {
      try {
        const restResourceService = new ApiClient();
        await restResourceService.getWorker(id)
          .then((res) => {
            detail.workerName = res.workerName;
            detail.lastName = res.lastName;
            detail.firstName = res.firstName;
            detail.lastNameKana = res.lastNameKana;
            detail.firstNameKana = res.firstNameKana;
            detail.genderId = res.genderId;
            detail.nationality = res.nationality;
            detail.email = res.email;
            detail.tel = res.tel;
            detail.postalCode = res.postalCode;
            detail.prefecture = res.prefecture;
            detail.city = res.city;
            detail.town = res.town;
            detail.otherAddress = res.otherAddress;
            detail.fullAddress = res.fullAddress;
            detail.nationalityObj = nationalityList.find((v) => v.id === detail.nationality);
            // this.getAddress(detail);
            // before
            before.workerName = res.workerName;
            before.lastName = res.lastName;
            before.firstName = res.firstName;
            before.lastNameKana = res.lastNameKana;
            before.firstNameKana = res.firstNameKana;
            before.genderId = res.genderId;
            before.nationality = res.nationality;
            before.email = res.email;
            before.tel = res.tel;
            before.postalCode = res.postalCode;
            before.prefecture = res.prefecture;
            before.city = res.city;
            before.town = res.town;
            before.otherAddress = res.otherAddress;
            before.fullAddress = res.fullAddress;
          });
      } catch (error) {
        this.errorMessage = error.message;
        throw error;
      }
    },
    // 変更ボタン押下時 更新処理
    async confirm() {
      // ボタン非活性化
      await this.startProcessing();
      // ====================入力項目空白削除====================
      this.detail.lastName = this.detail.lastName.trim();
      this.detail.firstName = this.detail.firstName.trim();
      this.detail.lastNameKana = this.detail.lastNameKana.trim();
      this.detail.firstNameKana = this.detail.firstNameKana.trim();
      if (this.detail.town) {
        this.detail.town = this.detail.town.trim();
      }
      if (this.detail.otherAddress) {
        this.detail.otherAddress = this.detail.otherAddress.trim();
      }
      if(this.detail.prefecture === undefined)this.detail.prefecture = '';
      if(this.detail.city === undefined)this.detail.city = '';
      if(this.detail.town === undefined)this.detail.town = '';
      // ====================入力チェック====================
      // 入力チェックメッセージ初期化
      this.validationErrMsg = [];
      // 郵便番号と住所の妥当性チェック(郵便番号,都道府県,市区町村)
      if (this.detail.postalCode) {
        if (!this.detail.prefecture || !this.detail.city) {
          this.validationErrMsg.push('住所を登録する場合、都道府県、市区町村、町・番地を入力して下さい');
        }
        if (this.detail.prefecture && this.detail.city && !this.detail.town) {
          this.validationErrMsg.push('住所を登録する場合、町・番地を入力して下さい');
        }
      }
      if (this.detail.nationality === 1) {
        this.detail.workerName = this.detail.lastName + this.detail.firstName;
      } else if (this.detail.nationality === 2) {
        this.detail.workerName = this.detail.firstName + this.detail.lastName;
      } else {
        this.validationErrMsg.push('国籍選択が不正です');
      }
      if (this.validationErrMsg.length !== 0) {
        return;
      }
      try {
        // フラグ初期化
        this.putErrorFlg = false;
        // ローディング表示
        this.postLodingFlg = true;
        this.detail.loginId = this.$route.params.loginId;
        this.detail.fullAddress = this.detail.prefecture + this.detail.city + this.detail.town + this.detail.otherAddress;
        // 技能者更新API呼出
        const body = {
          id: this.id,
          lastName: this.detail.lastName,
          firstName: this.detail.firstName,
          lastNameKana: this.detail.lastNameKana,
          firstNameKana: this.detail.firstNameKana,
          workerName: this.detail.workerName,
          genderId: this.detail.genderId,
          loginId: this.detail.loginId,
          email: this.detail.email,
          tel: this.detail.tel,
          postalCode: this.detail.postalCode,
          prefecture: this.detail.prefecture,
          city: this.detail.city,
          address: this.detail.town,
          otherAddress: this.detail.otherAddress,
          fullAddress: this.detail.fullAddress,
        };
        const restResourceService = new ApiClient();
        if (this.before.email !== this.detail.email) {
          // メールに使用するTemplateData
          const templateData = {
            oldMail: this.before.email,
            newMail: this.detail.email
          };
          await restResourceService.changeMail(this.detail.email, templateData);
        }

        await restResourceService.putWorker(body);
        history.back();
      } catch (error) {
        this.errorMessage = error.message;
        this.putErrorFlg = true;
      } finally {
        this.postLodingFlg = false;
      }
    },
    // 画面遷移
    screenTransition(path) {
      history.back();
    },
    isPostDisabled(item,isError){
      return common.isPostalValidate(item,isError,3)
    },
    // チャタリング防止
    async startProcessing() {
      this.processing = true;
    },
    async endProcessing() {
      this.processing = false;
    },
    async isProcessing() {
      return this.processing;
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";

.selectdiv {
  position: relative;
  float: left;
  min-width: 494px;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 494px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 20px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius: 10px;
  -ms-word-break: normal;
  word-break: normal;
}
</style>
